import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { FeatureConfirmationTranslationDictionary } from './feature-confirmation-dictionary.interface';

export const translation: TranslationDictionaryMapping<FeatureConfirmationTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      REGISTRATION_CONFIRMATION_PAGE_TITLE: "That's it, you're all set!",
      REGISTRATION_CONFIRMATION_PAGE_SUBTITLE:
        "Registration has been confirmed. We'll send you a confirmation email shortly.",
    },
    [LocaleId.English_Ireland]: {
      REGISTRATION_CONFIRMATION_PAGE_TITLE: "That's it, you're all set!",
      REGISTRATION_CONFIRMATION_PAGE_SUBTITLE:
        "Registration has been confirmed. We'll send you a confirmation email shortly.",
    },
  };
